import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../store';
import ToggleButtonListItem from '../../../../../list-items/ToggleButtonListItem';

const waveStyleOptions = [
    {value: 'solid', text: 'Solid'},
    {value: 'bar', text: 'Bar'},
    {value: 'point', text: 'Point'},
    {value: 'line', text: 'Line'},
];

const VisualizerWaveStyleListItem = (props) => {
    const { visualizerWaveStyle, updateVisualizerSettings } = props;
    const onStyleChange = (value) => updateVisualizerSettings({ waveStyle: value });
    
    return (
        <ToggleButtonListItem
            text='Style'
            value={visualizerWaveStyle}
            onChange={onStyleChange}
            options={waveStyleOptions}
        />
    );
};

const mapStateToProps = (state) => {
    const { waveStyle: visualizerWaveStyle } = state.createPreview.present.videoSettings.visualizer;
    return { visualizerWaveStyle };
}

const mapDispatchToProps = (dispatch) => {
    const updateVisualizerSettings = (properties) => dispatch(createActions.updateVisualizerSettings(properties));
    return { updateVisualizerSettings }
}

export default connect(mapStateToProps, mapDispatchToProps)(VisualizerWaveStyleListItem);